import React from "react";
import { useCategoryForm } from "../../hooks/useCategoryForm";
import { ModalWrapper } from "../../../../../components/ModalWrapper";
import CategoryNameField from "./CategoryNameField";
import CategoryTypeSelect from "./CategoryTypeSelect";
import CommonButtons from "../../../../../components/CommonButtons";

interface CategoryModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (categoryName: string, type: string) => void;
  initialName?: string;
  initialType?: string;
  isEdit?: boolean;
  businessType?: string;
  error?: boolean;
}

const CategoryModal: React.FC<CategoryModalProps> = ({ open, onClose, onSubmit, initialName = "", initialType = "", isEdit = false, businessType = "", error = false }) => {
  const { categoryName, type, hasError, setHasError, handleCategoryNameChange, handleTypeChange, resetForm } = useCategoryForm(initialName, initialType, error, open);

  // Only enable Confirm/Update if something changed in edit mode
   const isNameValid = categoryName.trim().length > 0;
   const visible = isEdit? isNameValid && (categoryName.trim() !== initialName || type !== initialType): isNameValid;

  const handleSubmit = () => {
    if (categoryName.trim()) {
      onSubmit(categoryName, type);
    } else {
      setHasError(true);
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && visible) handleSubmit();
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  if (!open) return null;

  return (
    <ModalWrapper title={isEdit ? "Edit Category" : "Add Category"} useTheme={true} onClose={handleClose} width="max-w-lg">
      <CategoryNameField value={categoryName} error={hasError} onChange={handleCategoryNameChange} onKeyPress={handleKeyPress} />

      {businessType === "Saloon" && <CategoryTypeSelect value={type} onChange={handleTypeChange} />}

      <div className="flex justify-end gap-3 mt-6">
        <CommonButtons className="w-36 h-10" label="Cancel" variant="outlineDanger" onClick={handleClose} />
        <CommonButtons className="w-36 h-10" label={isEdit ? "Update" : "Confirm"} onClick={visible ? handleSubmit : undefined} disabled={!visible} />
      </div>
    </ModalWrapper>
  );
};

export default CategoryModal;
